import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HistoryNavigationRepositoryService {
  
  constructor() { }
  
  history = [];
  
  getHistory = function() {
    return history;
  }
  ///Retourne l'id de la branche actuelle
  getCurrentBranch = function () {
    return this.history[this.history.length - 1].branchId;
  }
  
  ///Retourne l'id de la dernière question
  getLastQuestionId = function () {
    return this.history[this.history.length - 1].questionId;
  }
  
  ///Ajoute un élement dans l'historique de navigation (branche actuelle + id question actuelle)
  pushHistory = function (branchFromId, questionToId) {
    var currentHistory = {
      branchId: branchFromId,
      questionId: questionToId
    };
    this.history.push(currentHistory);
  };
  
  ///Supprime un élément de l'historique
  popHistory = function () {
    return this.history.pop();
  };
  
  resetHistory = function () {
    this.history = [];
  }
  
  isFirstQuestion = function() {
    return this.history.length == 1;
  }
  
  ///Retourne la taille du tableau de l'historique de navigation
  getHistorySize = function () {
    return this.history.length;
  }
}

